import { useApiClient } from '@hetivo/hetivo-lib-front-utils';
import type { Location } from '@hetivo/hetivo-lib-types';
import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import { createLocationApi, locationKeys } from '../api';

export function useLocation(id: string | null, enabled = true): UseQueryResult<Location> {
  const client = useApiClient('admin-auth');
  const api = createLocationApi(client);

  const locationId = id ?? '';

  return useQuery({
    enabled: enabled && id !== null,
    gcTime: 5 * 60_000,
    queryFn: () => api.getLocation(locationId),
    queryKey: locationKeys.detail(locationId),
    staleTime: 30_000,
  });
}
